import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DocumentFile } from '@app/interfaces/dm/document';
import { DocumentService } from '@services/dm/document.service';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.less',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileUploadComponent),
            multi: true,
        },
    ],
})
export class FileUploadComponent implements OnInit, OnChanges {
    @Input() formControlName = '';
    @Input() value: string[] = [];
    @Input() isMultiple = true;
    @Input() isSingleBtn = false;
    @Input() required = false;
    @Input() showUploadList = true;
    @Input() render?: TemplateRef<void>;
    @Input() batchUpload = false;
    @Input() inactiveUsers: boolean = false;
    @Output() valueChange = new EventEmitter();
    @Output() uploadEvent = new EventEmitter();

    uploadProcess = 0;
    fileList: DocumentFile[] = [];

    constructor(private message: NzMessageService,
                private kanbanBoardService: KanbanBoardService,
                private documentService: DocumentService) {
    }

    onChange: any = () => {
    };
    onTouch: () => void = () => null;

    ngOnInit(): void {
        this.initData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.initData();
        }
    }

    initData(): void {
        this.fileList = (this.value || []).map(it => {
            const fileItem = JSON.parse(it);
            const { fileId, fileName, fileSize, fileType, createdDate } = fileItem;
            return {
                id: fileId,
                name: fileName,
                size: fileSize,
                type: fileType,
                uid: fileId,
                createdDate,
                url: this.documentService.getPath(fileId),
            } as DocumentFile;
        });
        console.log('fileList', this.fileList);
    }

    writeValue(obj: string[]): void {
        this.value = obj;
        this.initData();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }


    async uploadSuccess(data: DocumentFile | DocumentFile[]): Promise<void> {
        let uploadList: DocumentFile[] = [];
        if (data instanceof Array) {
            uploadList = [...data];
        } else {
            uploadList = [data as DocumentFile];
        }
        console.log('uploadSuccess', data);
        this.uploadProcess = 0;
        const newFiles = uploadList.map(it => {
            return {
                ...it,
                url: this.documentService.getPath(it.id),
            };
        });
        this.fileList = [...this.fileList, ...newFiles];
        this.changeValue();
        this.message.success('Uploaded successfully');
        this.uploadEvent.emit(newFiles);
    }

    changeValue(): void {
        this.value = this.kanbanBoardService.formatFileList(this.fileList);
        this.valueChange.emit(this.value);
        if (!this.formControlName) {
            return;
        }
        this.onChange(this.value);
    }

    removeSuccess(): void {
        this.changeValue();
    }
}
